import en from '../lang/en'
import pl from '../lang/pl'
import './header.css'
import plLang from './pl.png'
import enLang from './en.png'
// 'use strict';
import {
  ButtonDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Dropdown
} from 'reactstrap'

var counterpart = require('counterpart')
var React = require('react')
var Translate = require('react-translate-component')

counterpart.registerTranslations('en', en)
counterpart.registerTranslations('pl', pl)
counterpart.setLocale('pl')

class LocaleSwitcher extends React.Component {
  state = {
    lang: 'pl',
    dropDownOpen: ''
  }

  toggle = () => {
    this.setState({
      dropDownOpen: !this.state.dropDownOpen
    })
  }

  handleChange = code => {
    this.setState({
      lang: code
    })

    counterpart.setLocale(code)
  }
  render () {
    return (
      <div className='selectorMargin navItemPadding'>
        <ButtonDropdown>
          <Dropdown isOpen={this.state.dropDownOpen} toggle={this.toggle}>
            <DropdownToggle
              id='langSelector'
              color='primary'
              caret
              className='dropdown-toggle'
            >
              {this.state.lang == 'en' && <img src={enLang} />}
              {this.state.lang == 'pl' && <img src={plLang} />}
              {this.state.lang}
            </DropdownToggle>
            <DropdownMenu className='currency-dropdown'>
              <DropdownItem
                onClick={() => this.handleChange('en')}
                dropDownValue='EN'
              >
                <img src={enLang} />
                EN
              </DropdownItem>
              <DropdownItem
                onClick={() => this.handleChange('pl')}
                dropDownValue='PL'
              >
                <img src={plLang} /> PL
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </ButtonDropdown>
      </div>
    )
  }
}

export default LocaleSwitcher
